import Featurebase, { onShow, whenReady, showArticle, showChangelog, showSpace, initFeedback, showNewMessage, FeaturebaseSettings } from "featurebase-js";
import { bus } from "./eventBus";
import { WebAnalytics } from "./webAnalytics";

export const initFeaturebase = (userJwt?: string) => {
	const appId = import.meta.env.VITE_FEATUREBASE_APP_ID;

	if (!appId || appId === "00000000") {
		console.warn("VITE_FEATUREBASE_APP_ID is not set");
		return;
	}

	let featurebaseConfig = {
		appId: appId,
		theme: "dark",
		language: "en",
		hideDefaultLauncher: true,
		alignment: "right",

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} as FeaturebaseSettings;

	if (userJwt) {
		featurebaseConfig = {
			...featurebaseConfig,
			featurebaseJwt: userJwt,
		};
	}

	Featurebase(featurebaseConfig);

	whenReady(() => {
		initFeedback({
			theme: "dark",
		});
		onShow(() => {
			WebAnalytics.trackFlexible("Featurebase Interaction", { action: "show" });
		});
		bus.on("messenger:show", () => {
			showSpace("home");
		});
		bus.on("messenger:show:article", (event: unknown) => {
			showArticle(event as string);
			WebAnalytics.trackFlexible("Featurebase Interaction", { action: "show:article", article: event as string });
		});
		bus.on("messenger:show:changelog", () => {
			showChangelog();
			WebAnalytics.trackFlexible("Featurebase Interaction", { action: "show:changelog" });
		});
		bus.on("messenger:show:space", (event: unknown) => {
			showSpace(event as string);
			WebAnalytics.trackFlexible("Featurebase Interaction", { action: "show:space", space: event as string });
		});
		bus.on("messenger:show:feedback", () => {
			window.postMessage({
				target: "FeaturebaseWidget",
				data: {
					action: "openFeedbackWidget",
				},
			});
		});
		bus.on("messenger:show:new-message", (event: unknown) => {
			showNewMessage(event as string);
			WebAnalytics.trackFlexible("Featurebase Interaction", { action: "show:new-message", message: event as string });
		});
	});
};

bus.on("messenger:init", () => {
	initFeaturebase();
});

bus.on("messenger:init:user", (event: unknown) => {
	initFeaturebase(event as string);
});
